// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".downloadGlossary{border:1px solid #c4d2ec;border-right:0px;border-top-left-radius:6px;border-bottom-left-radius:6px;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.downloadGlossary .icon{width:72px;height:72px}.downloadGlossary .downloadBtn{margin-top:5px;font-size:14px}\n", ""]);
// Exports
module.exports = exports;
